<template>
  <div class="hm-nav-tabs">
    <div class="hm-nav-tabs-box">
      <div class="hm-nav-tabs-item" :class="selectNum === index ?'active':''"  v-for="(item, index) of value.data" :key="item.id" @click="handleClick(item.id, index)">
        {{item.title}}
      </div>
    </div>
<!-- 对应的内容   -->
    <div class="hm-nav-tabs-con">
      <div v-for="(item, index) of value.data[selectNum].children" :key="index">
        <component :is="item.name" :value="item" />
      </div>
    </div>
  </div>
</template>
<script>
import config from "./config";
import { cloneDeep } from 'lodash'
export default {
  name: "HmNavigationTabs",
  wgtName: 'HmNavigationTabs',
  wgtDesc: 'hmtabs',
  wgtIcon: 'wgt-search',
  config: config,
  props: {
    value: [Object, Array]
  },
  data() {
    return {
      selectNum: 0
    }
  },
  created(){
    this.initDataFn()
  },
  methods: {
    initDataFn() {

    },
    handleClick(id, num) {
      this.selectNum = num
      // this.selectId = id
      // const data = this.value.data.filter((item) => {
      //   return item.id === id
      // })
      // this.selectData = data[0].children || []
    }
  }

}
</script>
<style scoped lang="scss">
.hm-nav-tabs{
  .hm-nav-tabs-box{
    width: 100%;
    height: 48px;
    background: white;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    .hm-nav-tabs-item{
      min-width: 25%;
      flex: 0 25%;
      padding: 0 16px;
      font-family: "Noto Sans SC";
      font-size: 13px;
      font-style: normal;
      font-weight: 700;
      letter-spacing: 0.13px;
      cursor: pointer;
      &.active{
        color: #000000;
      }
    }
  }
  .hm-nav-tabs-con{
    min-height: 500px;
  }
}
</style>
